import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { ArrowDownIcon } from '@depop/web-ui-kit/Icons/ArrowDownIcon';
import { ArrowForwardIcon } from '@depop/web-ui-kit/Icons/ArrowForwardIcon';
import clsx from 'clsx';

import styles from '../baseFilterStyles.module.css';

import { type TriggerComponentProps } from '@/components/Dropdown';

export function SearchFilterTrigger({
  isOpen,
  onClick,
  isActive,
  title,
  disabled,
}: TriggerComponentProps & { title: string }) {
  return (
    <button
      className={clsx(styles.searchFilterTrigger, {
        [styles.searchFilterTriggerActive]: isActive,
        [styles.searchFilterTriggerOpen]: isOpen,
        [styles.searchFilterTriggerDisabled]: disabled,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      <Body variant="sm-regular" className={styles.searchFilterTriggerText}>
        {title}
      </Body>
      <ArrowDownIcon size={16} className={styles.searchFilterTriggerChevron} />
      <ArrowForwardIcon
        size={16}
        className={styles.searchFilterTriggerForward}
      />
    </button>
  );
}
